import React from "react";
import HeroSearchForm2Mobile from "./HeroSearchForm2Mobile";
import HeroSearchForm2RealEstateMobile from "./HeroSearchForm2RealEstateMobile";
import { PathName } from "routers/types";
import { useLocation, useNavigate } from "react-router-dom";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

const PAGES_REAL_ESTATE: PathName[] = [
  "/home-2",
  "/listing-real-estate",
  "/listing-real-estate-map",
];

interface HeroSearchForm2MobileFactoryProps {
  isNavbar?: boolean;
}

const HeroSearchForm2MobileFactory: React.FC<HeroSearchForm2MobileFactoryProps> = ({ isNavbar = false }) => {
  const pathname = useLocation().pathname;
  const navigate = useNavigate();

  if (isNavbar) {
    return <HeroSearchForm2Mobile />;
  }

  if (pathname === "/") {
    return (
      <div className="HeroSearchForm2Mobile">
        <button
          onClick={() => navigate("/search")}
          className="relative flex items-center w-full border border-neutral-200 dark:border-neutral-6000 px-6 py-3 pr-12 rounded-full shadow-lg text-lg"
        >
          <MagnifyingGlassIcon className="flex-shrink-0 w-6 h-6" />

          <div className="ml-4 flex-1 text-left overflow-hidden">
            <span className="block font-medium text-base">Search Now</span>
          </div>
        </button>

      </div>
    );
  }

  return <HeroSearchForm2Mobile />;
};

export default HeroSearchForm2MobileFactory;